import request from '@/utils/request'
// import qs from 'qs'

// 获取动态码
export const getMessagePwd = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/mobile/code',
        data: params
    })
}
// 手机验证码登录
export const handlePhoneLogin = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/user/phoneLogin',
        data: params,
        headers: {
            moduleId: 1
        }
    })
}
// 账号密码登录
export const sendLoginInfo = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/user/login',
        data: params,
        headers: {
            moduleId: 1
        }
    })
}
// 注册
export const registerUser = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/user/register',
        data: params
    })
}
// 忘记密码-下一步
export const handleCodeCheck = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/mobile/codeCheck',
        data: params
    })
}
// 重置密码
export const resetPwd = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/user/resetKey',
        data: params
    })
}
// 查找旧用户名
export const getOldUserName = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/user/findName',
        data: params
    })
}
// 重置用户名
export const resetUserName = params => {
    return request({
        method: 'POST',
        url: '/lightweightdata/user/resetName',
        data: params
    })
}
// 刷新用户权限
export const permissions = () => {
    return request({
        method: 'POST',
        url: '/lightweightdata/refresh/permissions',
    })
}